import { useQuery } from '@tanstack/react-query';
import { axios } from './axios';
import { ExtractFnReturnType, QueryConfig } from "./queryConfig";


interface IFacilityDetails {
  id: string | undefined
}

type ResponseData = {
  id: string
  name: string
  map_default: string
  logo_url: string

}

export const getFacilityDetails = ({id}: IFacilityDetails): Promise<ResponseData> => {
  return axios.get(`/oe/facility/${id}`).then(res => res.data as ResponseData)
}

type QueryFnType = typeof getFacilityDetails;
interface IuseBarrierConfigAssetData extends IFacilityDetails {
  config: QueryConfig<QueryFnType>
}

export const useFacilityDetails = ({ id, config }: IuseBarrierConfigAssetData) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['barrierAuditId', id],
    queryFn: () => getFacilityDetails ({ id }),
    enabled: !!id,
    ...config

  })
}